export default {
  logList: [], //* 로그 리스트
};
